import { axiosGet, http } from '@/utils/http';
import store from '@/store';
import {log, validateJwt} from '@/utils/common';
import { ERRORS } from '@/utils/constants';

function keepSession(ssoToken = false) {
    const iframe = document.createElement('iframe');
    iframe.setAttribute(
        'src',
        `https://${process.env.SSO_HOST}/account/keepSession?SiteId=MPN`,
    );
    iframe.onload = () => {
      iframe.parentNode.removeChild(iframe);
      console.log("### keepSession Iframe onload ###");

      if(ssoToken) {
        store.dispatch("ssoToken");
      }
    };
    document.body.appendChild(iframe);
}

async function checkAboMember(userId) {
    log('auth::checkLoginStatus', 'checking member type...');
    const { result } = await http.post('/abo-info', {
        search_type: 'I',
    });

    return result;
}

async function checkLoginStatus(res) {
    const { token } = res;
    const payload = validateJwt(token);

    if (payload && payload.status === 'SUCCESS') {

      const customerUid= payload.sub;
      const loginId = payload.loginId;
      const name = payload.name;
      const bizNature = await checkAboMember(loginId);

      return {
        loginId,
        name,
        customerUid,
        bizNature
      };
    }

    log('auth::checkLoginStatus', 'not logged in');
    throw new Error(ERRORS.LOGIN.NOT_LOGGED_IN);
}

async function ssoLogin() {

    try {
        const res = await http.get(`/auth/login-status`);
        return checkLoginStatus(res);
    }
    catch (e) {
        //
        log('auth::ssoLogin', 'unknown exception', e);
        throw e;
    }
}

async function getSsoToken() {

  try {
    const result = await axiosGet.get('/enc/encrypt');
    return result.data.ssoToken;
  }
  catch (e) {
    //
    log('auth::ssoToken', 'unknown exception', e);
    throw e;
  }
}

export default {
  keepSession,
  ssoLogin,
  getSsoToken
};



// WEBPACK FOOTER //
// ./src/apis/auth.js